(function () {
  var root = document.querySelector('[data-oscar]');
  if (!root || root.dataset.oscarInit) return;
  root.dataset.oscarInit = '1';

  var endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
  var welcome = root.getAttribute('data-welcome') || '';
  var txtError = root.getAttribute('data-error') || '';
  var txtUnavailable = root.getAttribute('data-unavailable') || '';
  var loggedIn = root.getAttribute('data-logged-in') === 'true';
  var customerName = root.getAttribute('data-customer-name') || '';
  var pages = parseJSON(root.getAttribute('data-pages')) || [];
  var currentProduct = parseJSON(root.getAttribute('data-product'));
  var freeShipping = root.getAttribute('data-free-shipping') || '';

  var fab = root.querySelector('[data-oscar-open]');
  var overlay = root.querySelector('[data-oscar-overlay]');
  var drawer = root.querySelector('[data-oscar-drawer]');
  var closeBtn = root.querySelector('[data-oscar-close]');
  var resetBtn = root.querySelector('[data-oscar-reset]');
  var msgsEl = root.querySelector('[data-oscar-msgs]');
  var form = root.querySelector('[data-oscar-form]');
  var field = root.querySelector('[data-oscar-field]');
  var sendBtn = form ? form.querySelector('button[type="submit"]') : null;
  if (!fab || !drawer || !msgsEl || !form || !field) return;

  var STORE_KEY = 'paw-oscar-chat';
  var messages = load();
  var busy = false;
  var scrollY = 0;
  var typingEl = null;
  var gen = 0;
  var closeTimer = 0;
  var focusTimer = 0;

  function parseJSON(s) {
    if (!s) return null;
    try { return JSON.parse(s); } catch (e) { return null; }
  }
  function load() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || []; } catch (e) { return []; }
  }
  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(messages.slice(-40))); } catch (e) {}
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function safeHref(u) {
    u = String(u == null ? '' : u).trim();
    return (/^\/(?!\/)/.test(u) || /^https:\/\/(www\.)?paw\.de(\/|$)/.test(u)) ? u : '';
  }
  function renderMarkdown(text) {
    var out = escapeHtml(text);
    out = out.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (_, label, url) {
      var u = safeHref(url);
      return u ? '<a href="' + u + '" class="oscar-link">' + label + '</a>' : label;
    });
    out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return out;
  }
  function bubble(role, text) {
    var n = el('div', 'oscar-msg oscar-msg--' + (role === 'user' ? 'user' : 'bot'));
    if (role === 'user') n.textContent = text;
    else n.innerHTML = renderMarkdown(text);
    return n;
  }
  function cardsEl(cards) {
    var wrap = el('div', 'oscar-cards');
    cards.forEach(function (p) {
      var href = safeHref(p.url);
      if (!href) return;
      var a = el('a', 'oscar-card');
      a.href = href;
      if (p.image) {
        var img = el('img', 'oscar-card__img');
        img.src = p.image; img.alt = p.title || ''; img.loading = 'lazy';
        a.appendChild(img);
      }
      var body = el('div', 'oscar-card__body');
      body.appendChild(el('div', 'oscar-card__title', p.title));
      if (p.price) body.appendChild(el('div', 'oscar-card__price', p.price));
      a.appendChild(body);
      wrap.appendChild(a);
    });
    return wrap;
  }
  function scrollDown() { msgsEl.scrollTop = msgsEl.scrollHeight; }

  function renderAll() {
    msgsEl.innerHTML = '';
    if (messages.length === 0 && welcome) {
      messages.push({ role: 'bot', text: welcome });
      save();
    }
    messages.forEach(function (m) {
      msgsEl.appendChild(bubble(m.role, m.text));
      if (m.cards && m.cards.length) msgsEl.appendChild(cardsEl(m.cards));
    });
    scrollDown();
  }

  function showTyping() {
    typingEl = el('div', 'oscar-typing');
    typingEl.appendChild(el('span'));
    typingEl.appendChild(el('span'));
    typingEl.appendChild(el('span'));
    msgsEl.appendChild(typingEl);
    scrollDown();
  }
  function hideTyping() { if (typingEl) { typingEl.remove(); typingEl = null; } }

  function open() {
    if (root.classList.contains('is-open')) return;
    clearTimeout(closeTimer);
    overlay.hidden = false;
    drawer.hidden = false;
    drawer.getBoundingClientRect();
    root.classList.add('is-open');
    fab.setAttribute('aria-expanded', 'true');
    lockScroll();
    if (msgsEl.children.length === 0) renderAll();
    clearTimeout(focusTimer);
    focusTimer = setTimeout(function () {
      if (!root.classList.contains('is-open')) return;
      if (window.matchMedia('(min-width: 768px) and (hover: hover)').matches) field.focus({ preventScroll: true });
      else if (closeBtn) closeBtn.focus({ preventScroll: true });
    }, 400);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    if (document.activeElement === field) field.blur();
    clearTimeout(focusTimer);
    root.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    unlockScroll();
    drawer.style.height = '';
    drawer.style.transform = '';
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      overlay.hidden = true;
      drawer.hidden = true;
      fab.focus({ preventScroll: true });
    }, 380);
  }
  function lockScroll() {
    if (document.body.dataset.oscarScrollLocked === '1') return;
    if (document.body.style.position === 'fixed') return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.dataset.oscarScrollLocked = '1';
  }
  function unlockScroll() {
    if (document.body.dataset.oscarScrollLocked !== '1') return;
    delete document.body.dataset.oscarScrollLocked;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function getFocusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE),
      function (n) { return n.offsetParent !== null; }
    );
  }
  function handleTab(e) {
    if (e.key !== 'Tab') return;
    var list = getFocusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus({ preventScroll: true }); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus({ preventScroll: true }); }
  }

  var vv = window.visualViewport;
  var vvRaf = 0;
  var blurTimer = 0;
  function applyViewport() {
    vvRaf = 0;
    if (!vv || !root.classList.contains('is-open')) return;
    var dist = msgsEl.scrollHeight - msgsEl.scrollTop - msgsEl.clientHeight;
    var stick = dist < 40;
    var hidden = Math.round(window.innerHeight - vv.height);
    if (hidden > 120) {
      drawer.style.height = Math.round(vv.height) + 'px';
      drawer.style.transform = 'translateY(' + Math.round(vv.offsetTop) + 'px)';
    } else {
      drawer.style.height = '';
      drawer.style.transform = '';
    }
    if (stick) msgsEl.scrollTop = msgsEl.scrollHeight;
  }
  function queueViewport() {
    if (vvRaf) return;
    vvRaf = requestAnimationFrame(applyViewport);
  }
  if (vv) {
    vv.addEventListener('resize', queueViewport);
    vv.addEventListener('scroll', queueViewport);
  }
  field.addEventListener('focus', queueViewport);
  field.addEventListener('blur', function () {
    clearTimeout(blurTimer);
    blurTimer = setTimeout(function () {
      if (!vv || !root.classList.contains('is-open')) return;
      if (Math.round(window.innerHeight - vv.height) <= 120) {
        window.scrollTo(0, 0);
      }
      queueViewport();
    }, 250);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    clearTimeout(closeTimer);
    clearTimeout(focusTimer);
    drawer.style.height = '';
    drawer.style.transform = '';
    root.classList.remove('is-open');
    overlay.hidden = true;
    drawer.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    unlockScroll();
  });

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return [];
        return c.items.slice(0, 10).map(function (i) {
          return { title: i.product_title || i.title, qty: i.quantity };
        });
      })
      .catch(function () { return []; });
  }

  function fetchProducts(query) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
    return fetch(u, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        return list.map(function (p) {
          return {
            title: p.title,
            url: p.url,
            price: p.price || '',
            image: (p.featured_image && p.featured_image.url) || p.image || ''
          };
        }).filter(function (p) { return p.title && p.url; });
      })
      .catch(function () { return []; });
  }

  function send(text) {
    if (busy || !text) return;
    if (!endpoint) {
      msgsEl.appendChild(bubble('bot', txtUnavailable));
      scrollDown();
      return;
    }
    busy = true;
    if (sendBtn) sendBtn.disabled = true;
    var myGen = gen;

    messages.push({ role: 'user', text: text });
    msgsEl.appendChild(bubble('user', text));
    save();
    scrollDown();
    showTyping();

    getCart().then(function (cart) {
      if (myGen !== gen) return null;
      var convo = messages.map(function (m) {
        return { role: m.role === 'user' ? 'user' : 'model', text: m.text };
      });
      while (convo.length && convo[0].role !== 'user') { convo.shift(); }
      var payload = {
        messages: convo,
        context: {
          page: location.pathname + location.search,
          loggedIn: loggedIn,
          customerName: customerName || undefined,
          cart: cart,
          pages: pages,
          product: currentProduct || undefined,
          freeShipping: freeShipping || undefined
        }
      };
      return fetch(endpoint + '/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    }).then(function (r) {
      if (myGen !== gen || !r) return null;
      if (!r.ok) throw new Error('bad_response');
      return r.json();
    }).then(function (data) {
      if (myGen !== gen || !data) return;
      hideTyping();
      var reply = (data && data.reply) || txtError;
      var entry = { role: 'bot', text: reply };
      messages.push(entry);
      msgsEl.appendChild(bubble('bot', reply));
      scrollDown();
      save();
      if (data && Array.isArray(data.products) && data.products.length) {
        entry.cards = data.products;
        msgsEl.appendChild(cardsEl(data.products));
        scrollDown();
        save();
      } else if (data && data.product_query) {
        return fetchProducts(data.product_query).then(function (cards) {
          if (myGen !== gen) return;
          if (cards.length) {
            entry.cards = cards;
            msgsEl.appendChild(cardsEl(cards));
            scrollDown();
            save();
          }
        });
      }
    }).catch(function () {
      if (myGen !== gen) return;
      hideTyping();
      msgsEl.appendChild(bubble('bot', txtError));
      scrollDown();
    }).finally(function () {
      if (myGen !== gen) return;
      busy = false;
      if (sendBtn) sendBtn.disabled = false;
    });
  }

  fab.addEventListener('click', open);
  document.addEventListener('oscar:open', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  if (resetBtn) resetBtn.addEventListener('click', function () {
    gen++;
    messages = [];
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    hideTyping();
    busy = false;
    if (sendBtn) sendBtn.disabled = false;
    msgsEl.innerHTML = '';
    renderAll();
    field.value = '';
    if (window.matchMedia('(min-width: 768px) and (hover: hover)').matches) field.focus({ preventScroll: true });
  });
  if (sendBtn) sendBtn.addEventListener('pointerdown', function (e) { e.preventDefault(); });
  msgsEl.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a && msgsEl.contains(a)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else handleTab(e);
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = (field.value || '').trim();
    if (!v) return;
    field.value = '';
    send(v);
  });
})();
